import { render, staticRenderFns } from "./InputCatatanKas.vue?vue&type=template&id=15357d5e&scoped=true&"
import script from "./InputCatatanKas.vue?vue&type=script&lang=js&"
export * from "./InputCatatanKas.vue?vue&type=script&lang=js&"
import style0 from "./InputCatatanKas.vue?vue&type=style&index=0&id=15357d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15357d5e",
  null
  
)

export default component.exports